import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
  KeyValuePair,
} from 'src/shared/shared.types';

export type C41TableProps = RenderingProps<C41TableFields, C41TableRenderingParams>;

export type C41TableFields = {
  table?: TableFields;
};

export type C41TableRenderingParams = {
  ContentAlignment?: string;
  HeadlineTag?: string;
  TableStyling?: string;
  PinFirstColumn?: string;
  CellAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export interface TableCellFields {
  TableData?: RichTextField;
  Icon?: KeyValuePair;
  CellAlignment?: KeyValuePair;
  children?: ChildItemData[];
}

export interface DataRowFields {
  CellAlignment?: KeyValuePair;
}

export interface HeaderRowFields {
  CellAlignment?: KeyValuePair;
}

export interface TableFields {
  fields?: {
    Headline?: Field<string>;
    SupportCopy?: RichTextField;
  };
  children?: ChildItemData[];
}

export interface ChildItemData {
  id?: string;
  templateId?: string;
  name?: string;
  fields?: TableCellFields | DataRowFields | HeaderRowFields;
  children?: ChildItemData[];
}
